import { NavigationContainerRefWithCurrent } from '@react-navigation/native'
import React from 'react'

import { EmojiButton } from 'pages/CreatePostModal/subcomponents/EmojiButton'

import { Box } from 'widgets/Box'

import { links } from 'utils/constants'

import { useCreatePostModal } from 'contexts/CreatePostModalContext'

export const ActionTypeSelection = ({
  onAdd,
  programId,
  drawerNavigationRef,
}: {
  onAdd: string
  programId: string
  drawerNavigationRef: NavigationContainerRefWithCurrent<ReactNavigation.RootParamList>
}) => {
  const createPostModalRef = useCreatePostModal()

  return (
    <Box
      testID='ActivityGroupSelectionPage'
      flexDirection='column'
      backgroundColor='white'
      flex={1}
    >
      <Box testID='CreatePostTypeGroups' padding={{ top: 'smd' }}>
        <Box flexDirection='row' align='center' justifyContent='center'>
          <EmojiButton
            emoji='🏋🏻‍♂️'
            isSingleRow={false}
            title='New'
            subtitle='Build a new action or workout from scratch'
            onPress={() => {
              createPostModalRef?.current?.dismiss()
              drawerNavigationRef.navigate(links.CREATE_WORKOUT_PAGE, { onAdd, programId })
            }}
          />
          <EmojiButton
            emoji='♻️'
            isSingleRow={false}
            title='Existing'
            subtitle='Add one of your existing actions or workouts'
            onPress={() => {
              createPostModalRef?.current?.dismiss()
              drawerNavigationRef.navigate(links.ACTIONS_LIST_PAGE, { onAdd })
            }}
          />
        </Box>
      </Box>
    </Box>
  )
}
